<template>
  <div>
    <v-dialog
      max-width="500px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Compensation
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row>
              <v-col cols="12" md="6" lg="6">
              <h3>Compensation Type</h3>
               <v-select
                hide-details
                :items="compensation_types"
                item-value="Compensation_Type_ID"
                item-text="Compensation_Name"
                v-model="currentCompensation.Compensation_Type_ID"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h3>Date of Update</h3>
                <DatePicker
                  v-model="currentCompensation.Date_of_Update"
                  @onDatePickerChange="onChange(currentCompensation.Date_of_Update)"
                />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <h3>Amount</h3>
              <v-text-field
                v-model="currentCompensation.Compensation_Amount"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h3>Currency</h3>
               <v-select
                hide-details
                :items="currencyItems"
                item-value="Compensation_Currency"
                item-text="Compensation_Currency"
                v-model="currentCompensation.Compensation_Currency"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="saveCompensation" :disabled="saveCompensationDisable">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'CompensationEditor',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false
    },
    currentCompensation: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      saveCompensationDisable: false,
      compensation_types: null,
      currencyItems: [
        { Compensation_Currency: 'UAH' },
        { Compensation_Currency: '$' }
      ]
    }
  },
  computed: {
    show: {
      get () {
        this.getCompensationTypes()
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    date: {
      get () {
        return this.currentCompensation.Date_of_Update
      },
      set (val) {
        this.$emit('input', val || null)
      }
    }
  },
  mounted () {
    this.getCompensationTypes()
  },
  methods: {
    getCompensationTypes () {
      this.axios.get('/api/payroll/compensation_types', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.compensation_types = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    saveCompensation () {
      this.saveCompensationDisable = true
      if (this.addMode) {
        const body = {
          Compensation_Type_ID: this.currentCompensation.Compensation_Type_ID,
          Date_of_Update: this.currentCompensation.Date_of_Update,
          Compensation_Amount: this.currentCompensation.Compensation_Amount,
          Compensation_Currency: this.currentCompensation.Compensation_Currency
        }
        this.axios.post('/api/payroll/compensation', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.saveCompensationDisable = false
          this.$store.dispatch('setSuccess', { successMsg: 'Compensation succesefully added' })
          this.show = false
        }).catch(error => {
          this.saveCompensationDisable = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.put(`/api/payroll/compensation/${this.currentCompensation.Compensation_Amount_ID}`, this.currentCompensation, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.saveCompensationDisable = false
          this.$store.dispatch('setSuccess', { successMsg: 'Compensation succesefully updated' })
          this.show = false
        }).catch(error => {
          this.saveCompensationDisable = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    onChange (date) {
      this.date = date
    }
  }
}
</script>
